import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class WoodenDesk extends DestroyableObstacle {
	static key = "WoodenDesk";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.WOOD_DEBRIS;
	}

	static deserialize(data: any): WoodenDesk {
		const d = new WoodenDesk(deserializeXY(data.xy));
		d.restoreBaseFields(data);
		return d;
	}
}
